import React from 'react';

function Somalia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123995)">
        <mask
          id="mask0_800_123995"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123995)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#56C6F5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2012 14.7174L13.9668 17.1105L15.3871 12.9212L12.3668 10.1841L16.5308 10.1032L18.373 5.96737L20.0518 10.1578L24.2058 10.2223L21.0841 13.0096L22.5418 16.995L18.2012 14.7174Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123995">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Somalia;
